import { render, staticRenderFns } from "./NotFoundComponent.vue?vue&type=template&id=d2e0bce2&scoped=true"
import script from "./NotFoundComponent.vue?vue&type=script&lang=js"
export * from "./NotFoundComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e0bce2",
  null
  
)

export default component.exports